<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>

		<main-content>
			<template #content>
				<div class="columns column6">
					<h1>{{ page.title || page.header }}</h1>
					<div class="room-icons">
						<div v-if="page.pax" class="room-icon">
							<font-awesome-icon class="icon-margin" :icon="`fal fa-users`" size="1x" />
							<span>{{ page.pax }}</span>
						</div>
						<div v-if="page.surface" class="room-icon">
							<font-awesome-icon class="icon-margin" :icon="`fal fa-ruler-combined`" size="1x" />
							<span>{{ page.surface }}</span>
						</div>
					</div>
					<div v-parse-links v-html="page.content" />
					<book-button v-if="page.bookingID" :room-i-d="page.bookingID" class="button">
						{{ $t('bookThisRoom') }}
					</book-button>
				</div>
			</template>
			<template #right-content>
				<div v-parse-links class="columns column6" v-html="page.rightContent" />
			</template>
		</main-content>

		<div class="main-content" :class="page.gallery && page.gallery.length ? 'gallery-section' : 'button-section'">
			<div class="row row-gallery">
				<div v-for="(item, index) in page.gallery" :key="index">
					<a
						v-if="item.images.length"
						:data-src="item.images[0]"
						class="gallery-item"
						data-fancybox="gallery"
						:data-caption="item.imageAlt"
						rel="Gallery"
						:title="item.imageAlt"
					>
						<picture>
							<source :srcset="item.imagesWebp[1]" type="image/webp" />
							<source :srcset="item.images[1]" />
							<img :src="item.images[1]" :alt="item.imageAlt" loading="lazy" />
						</picture>
					</a>
				</div>
			</div>
			<div class="row">
				<div class="columns column12">
					<button-container>
						<nuxt-link :to="localePath('rooms')" class="button button-no-fill">
							{{ defaults[locale].rooms.more }}
						</nuxt-link>
					</button-container>
				</div>
			</div>
		</div>

		<contentblocks
			v-if="page.contentblocks && page.contentblocks.length"
			:contentblocks="page.contentblocks"
			:contentblocks-content="page.contentBlockContent"
		/>

		<frequently-asked-questions
			v-if="page.frequentlyAskedQuestion"
			:header="page.frequentlyAskedQuestion.header"
			:items="page.frequentlyAskedQuestion.faqitems"
		/>
		<pre-footer v-if="page.footerSection && page.footerSection.length" :footer-section="page.footerSection[0]" />
		<newsletter
			v-if="page.showNewsletter"
			:header="defaults[locale].newsletterForm.title"
			:content="defaults[locale].newsletterForm.content"
			:email="defaults[locale].newsletterForm.email"
			:button="defaults[locale].newsletterForm.button"
		/>
	</page-container>
</template>

<script setup>
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

const { page, fetchPage } = usePage();
const { defaults, fetchDefaults } = useDefaults();
const { locale } = useI18n();

await fetchPage();
await fetchDefaults();

onMounted(() => {
	Fancybox.bind('[data-fancybox]', {});
});
</script>

<style lang="scss" scoped>
.gallery-section {
	padding-top: 0;
	margin-top: -40px;

	.row-gallery {
		display: grid;
		grid-template-columns: 1fr 1fr;
		gap: 60px;
		padding: 30px;
	}

	img {
		width: 100%;
	}
}

.room-icons {
	display: flex;
	flex-flow: wrap row;
	justify-content: flex-start;
	align-items: center;
	gap: 10px;
	margin: 0 0 20px;

	.room-icon {
		margin: 0 20px 0 0;
	}

	span {
		font-size: 12px;
	}

	svg {
		color: $primary-color;
	}
}

.button-section {
	padding: 0 0 100px;
}

@media (max-width: 960px) {
	.gallery-section .row-gallery {
		grid-template-columns: 1fr;
	}
}
</style>
